import React from 'react';
import Link from '../../components/Links/link';
import { useTranslation } from 'react-i18next';

export default function Footer() {
    const { t } = useTranslation();

    return (
        <div className='w-full relative'>
            <div className="bg-footer mx-auto flex flex-col space-y-6 p-4 px-4 sm:px-6 lg:px-8">
                <div className="mt-8 mb-4 flex flex-col md:flex-row gap-4 items-center md:justify-evenly">
                    <p className='text-white'>
                        <Link link="https://storage.googleapis.com/fiska-public/FISKA/Mentions_l%C3%A9gales.pdf" externalLink={true} text={t('footer.legalNotices')} textColor='white' />
                    </p>
                    <p className='text-white'>
                        <Link link="https://storage.googleapis.com/fiska-public/FISKA/CGV-FISKAGROUP.pdf" text={t('footer.generalConditions')} textColor='white' />
                    </p>
                    <p className='text-white'>
                        <Link link="https://storage.googleapis.com/fiska-public/FISKA/Donn%C3%A9es_personnelles.pdf" text={t('footer.personalData')} textColor='white' />
                    </p>
                </div>
            </div>

            <div className='bg-footer'>
                <div className='text-center text-white opacity-60 p-2'>
                    <span>
                        Copyright © {new Date().getFullYear()} FISKA\Group. Tous les droits sont réservés.
                        {/* &nbsp;|&nbsp;
                        <Link link="tel:+33387885670" text="+33 (0)3 87 88 56 70" textColor='white' disableHoverEffect={true} />
                        &nbsp;|&nbsp;
                        <Link link="mailto:info@fiskagroup.com" text="info@fiskagroup.com" textColor='white' disableHoverEffect={true} /> */}
                    </span>
                </div>
            </div>
        </div>
    );
}